import { render, staticRenderFns } from "./MessageAddView.vue?vue&type=template&id=db524f92"
import script from "./MessageAddView.vue?vue&type=script&lang=js"
export * from "./MessageAddView.vue?vue&type=script&lang=js"
import style0 from "./MessageAddView.vue?vue&type=style&index=0&id=db524f92&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports